export default __webpack_public_path__ + "static/media/Believer's Robes of Yag.ac7f96f2.jpg";